module.exports = __webpack_public_path__ + "static/img/select-img10.72c68f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/select-img10.png
// module id = vFcQ
// module chunks = 1